import { Account, useManualSyncRequired } from "@rentablo/api/apiv1";

export type AccountWithSyncRequired = Account & { syncRequired: boolean };

export const useAccountsWithSyncRequired = (
  accounts: Account[]
): AccountWithSyncRequired[] => {
  const acccountsWithBankConnection = accounts.filter((account) =>
    Boolean(account.bankConnectionId)
  );

  const { data: syncRequiredStatuses } = useManualSyncRequired(
    {
      accountId: acccountsWithBankConnection.map((account) => account.id),
    },
    {
      enabled: acccountsWithBankConnection.length > 0,
    }
  );

  return accounts.map((account) => ({
    ...account,
    syncRequired:
      (Boolean(account.bankConnectionId) &&
        syncRequiredStatuses?.syncStatuses?.find(
          (status) => status.accountId === account.id
        )?.manualSyncRequired) ||
      false,
  }));
};
